// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { jettinAppActionsStyles } from "@stoneage/App/Components/JettingAppComponents/JettinAppActions";
import IconShareEmail from "@stoneage/XDL/Icons/IconShareEmail";
import IconShareLink from "@stoneage/XDL/Icons/IconShareLink";
import IconSharePrint from "@stoneage/XDL/Icons/IconSharePrint";
import { createLinkIconStyles } from "@stoneage/XDL/Utilities/SharedStyles/sharedStyles";
import { css } from "styled-components";

jettinAppActionsStyles.printLink = {
    ...createLinkIconStyles(IconSharePrint, "small"),
};

jettinAppActionsStyles.copyLink = {
    ...createLinkIconStyles(IconShareLink, "small"),
};

jettinAppActionsStyles.emailLink = {
    ...createLinkIconStyles(IconShareEmail, "small", "left", {
        css: css`
            ${IconWrapper}, ${IconWrapper} svg {
                width: 12px;
            }
        `,
    }),
};
jettinAppActionsStyles.wrapper = {
    css: css`
        display: flex;
        column-gap: 24px;
        padding: 16px 12px;
    `,
};
jettinAppActionsStyles.buttonsWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        padding-top: 20px;
    `,
};
jettinAppActionsStyles.modal = {
    size: 328,
};
